if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList.contains('f8vl')) {
                   BSS_B2B.observer.cartSubject.listenCartCheckout()
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
}

if(typeof BSS_B2B != undefined) {
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const debouncedHandlePrice = debounce(() => {
    const productForm = document.querySelector("[bss-b2b-main-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
  }, 200);

  function setupMainProduct() {
    const mainProduct = document.querySelector("[bss-b2b-main-product-form]");
    if (!mainProduct) return;

    const mainObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (
                mutation.target.classList.contains('f8pr')
              ) {
                debouncedHandlePrice()
                break;
              }
        }
    })

    mainObserver.observe(mainProduct, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        subtree: true,
    });
  }
  
  setTimeout(setupMainProduct, 2000);

  //fix quickview
  setTimeout(() => {
    const quickViewBtn = document.querySelectorAll("[bss-b2b-btn-quickview]");
  
    if (quickViewBtn.length) {
      for (let i = 0; i < quickViewBtn.length; i++) {
        quickViewBtn[i].onclick = function () {
          setTimeout(setupMainProduct, 1500);
        };
      }
    }
  }, 3000);
  
}

